/*
  KI-Kennzeichnung von Bildern (EU AI Act, Art. 50)

  Ergaenzung zu snippets/ai-image-badge.liquid:
  Produktbilder werden serverseitig in Liquid gekennzeichnet. Dieses Skript
  uebernimmt alle uebrigen Bildflaechen (Startseite, Banner, Collage,
  Multicolumn, Kollektionskacheln, Blog, Seiten) - dort rendert jede Section
  ihr eigenes Bild-Markup, es gibt also keine gemeinsame Stelle in Liquid.

  Konfiguration kommt aus window.aiImageBadgeConfig, das layout/theme.liquid
  aus dem Snippet befuellt. Einzige Konfigurationsstelle bleibt das Snippet.
*/

(function () {
  'use strict';

  var cfg = window.aiImageBadgeConfig || {};
  if (cfg.enabled === false || !cfg.marker) return;

  var MARKER = cfg.marker;
  var LABEL = cfg.label || 'KI-generiert';
  var REPLACEMENT = cfg.altReplacement || '(KI-generiert)';
  var POSITION = cfg.position || 'bottom-right';
  var STYLE = cfg.style || 'dark';
  var SMALL_BREAKPOINT = 320;
  var MAX_HOST_DEPTH = 3;

  var ICON =
    '<svg class="ai-badge__icon" viewBox="0 0 24 24" role="presentation" focusable="false">' +
    '<path d="M11 2.5l1.65 4.35a3 3 0 0 0 1.75 1.75L18.75 10.25l-4.35 1.65a3 3 0 0 0-1.75 1.75L11 18l-1.65-4.35a3 3 0 0 0-1.75-1.75L3.25 10.25l4.35-1.65a3 3 0 0 0 1.75-1.75z" fill="currentColor"/>' +
    '<path d="M18 14l.66 1.74a1.5 1.5 0 0 0 .87.87L21.27 17.25l-1.74.66a1.5 1.5 0 0 0-.87.87L18 20.5l-.66-1.72a1.5 1.5 0 0 0-.87-.87L14.73 17.25l1.74-.64a1.5 1.5 0 0 0 .87-.87z" fill="currentColor"/>' +
    '</svg>';

  function buildBadge(isSmall) {
    var badge = document.createElement('span');
    badge.className =
      'ai-badge ai-badge--' + POSITION + ' ai-badge--' + STYLE + (isSmall ? ' ai-badge--sm' : '');
    badge.setAttribute('aria-hidden', 'true');
    badge.setAttribute('data-ai-badge', 'js');
    badge.innerHTML = ICON + '<span class="ai-badge__text"></span>';
    badge.lastChild.textContent = LABEL;
    return badge;
  }

  /* Sucht den naechsten Container, in dem das Badge absolut positioniert
     werden kann. Faellt auf das direkte Elternelement zurueck. */
  function findHost(img) {
    var el = img.parentElement;
    var depth = 0;

    while (el && depth < MAX_HOST_DEPTH) {
      if (el.classList.contains('ai-badge-host')) return el;

      var position = window.getComputedStyle(el).position;
      if (position !== 'static' && el.offsetWidth > 0) return el;

      el = el.parentElement;
      depth++;
    }

    return img.parentElement;
  }

  function decorate(img) {
    var alt = img.getAttribute('alt');
    if (!alt || alt.indexOf(MARKER) === -1) return;

    img.setAttribute(
      'alt',
      alt.split(MARKER).join(REPLACEMENT).replace(/\s+/g, ' ').trim()
    );

    var host = findHost(img);
    if (!host || host.querySelector(':scope > .ai-badge')) return;

    if (window.getComputedStyle(host).position === 'static') {
      host.classList.add('ai-badge-host');
    }

    var width = img.clientWidth || host.offsetWidth || 0;
    host.appendChild(buildBadge(width > 0 && width < SMALL_BREAKPOINT));
  }

  function scan(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var images = scope.querySelectorAll('img');
    for (var i = 0; i < images.length; i++) decorate(images[i]);
  }

  var pending = false;
  function scheduleScan() {
    if (pending) return;
    pending = true;
    window.requestAnimationFrame(function () {
      pending = false;
      scan(document);
    });
  }

  function init() {
    scan(document);

    if (window.MutationObserver) {
      new MutationObserver(function (mutations) {
        for (var i = 0; i < mutations.length; i++) {
          if (mutations[i].addedNodes.length) {
            scheduleScan();
            return;
          }
        }
      }).observe(document.body, { childList: true, subtree: true });
    }

    /* Theme-Editor: Sections werden live neu gerendert */
    document.addEventListener('shopify:section:load', scheduleScan);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
